import { Blog } from '@commerce/types/blog'
import BlogContainer from '@components/blogs/BlogContainer'
import BlogList from '@components/blogs/BlogList'
import BlogWrapper from '@components/blogs/BlogWrapper'
import { Layout } from '@components/common'
import commerce from '@lib/api/commerce'
import getGlobalStaticProps from '@lib/get-global-static-props'
import { createClient } from '@lib/prismicio'
import { GetStaticPathsContext, GetStaticPropsContext } from 'next'

export async function getStaticProps({
  params,
  locale,
  locales,
  preview,
  previewData,
}: GetStaticPropsContext<{ slug: string }>) {
  const blogHandle = 'news'
  const config = { locale, locales }

  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)

  const { blog } = await commerce.getBlogByHandle({
    variables: {
      handle: blogHandle,
    },
    config,
  })

  if (!blog) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      ...globalProps,
      ...config,
      blog,
    },
  }
}

interface Props {
  blog: Blog
  locale: string
  locales: string[]
}

interface BlogLayoutProps {
  pageProps: Props
  children: React.ReactNode
}

export default function BlogIndex(props: Props) {
  const { blog } = props
  return (
    <BlogWrapper blog={blog}>
      <BlogContainer>
        <BlogList blog={blog} />
      </BlogContainer>
    </BlogWrapper>
  )
}

BlogIndex.Layout = Layout
